import React from 'react';
import {
  AnimatedDiv,
  ShowAnimation,
} from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { Service } from '~/types/models';
import cx from 'classnames';

export enum PricingCtaShowType {
  Placeholder = 'placholder',
  Button = 'button',
}

export interface PricingCtaPanelProps {
  showType?: PricingCtaShowType;
  variant?: ButtonVariant;
  service?: Service;
  onCtaClick?: () => void;
  placeholder?: string;
}

export function PricingCtaPanel({
  showType,
  variant = ButtonVariant.Primary,
  onCtaClick,
  service,
  placeholder = 'Current plan',
}: PricingCtaPanelProps) {
  return (
    <div className='h-[40px] w-full flex items-center justify-center'>
      {showType === PricingCtaShowType.Placeholder && (
        <AnimatedDiv
          show
          showAnimation={ShowAnimation.SlideInRight150}
          className='w-full text-center'
        >
          <span
            className={cx('text-base font-bold', {
              'v2-text-blue-500': service === Service.VideoMessaging,
              'v2-text-magenta-500': service === Service.Testimonials,
            })}
          >
            {placeholder}
          </span>
        </AnimatedDiv>
      )}
      {showType === PricingCtaShowType.Button && (
        <AnimatedDiv
          show
          showAnimation={ShowAnimation.SlideInLeft150}
          className='w-full'
        >
          <Button
            variant={variant}
            className='py-2 w-full'
            onClick={onCtaClick}
          >
            Select plan
          </Button>
        </AnimatedDiv>
      )}
    </div>
  );
}
